module.exports = __webpack_public_path__ + "static/media/decide.92d0cc2d.jpeg";